import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stripe-logo',
  templateUrl: './stripe-logo.component.html',
  styleUrls: ['./stripe-logo.component.scss']
})
export class StripeLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
